import { t } from "@i18n";
import {
  DEFAULT_SEQUENCE_TYPE,
  CUSTOM_SEQUENCE_TYPE,
  type RevisionSequenceRules,
  type RevisionSequenceType,
} from "@Helpers/revisionPattern";

export type RevisionSeriesDefaultBehavior = "MANUAL" | "ALWAYS_NEW" | "ALWAYS_PREVIOUS";

export const DEFAULT_BEHAVIOR_OPTIONS: { value: RevisionSeriesDefaultBehavior; label: string }[] = [
  { value: "MANUAL", label: t("Manually specify every time") },
  { value: "ALWAYS_NEW", label: t("Always Create New Revision") },
  { value: "ALWAYS_PREVIOUS", label: t("Always Use Previous Revision") },
];

export const SEQUENCE_TYPE_OPTIONS: { value: RevisionSequenceType; label: string }[] = [
  { value: DEFAULT_SEQUENCE_TYPE, label: t("Standard (increment the start pattern)") },
  {
    value: CUSTOM_SEQUENCE_TYPE,
    label: t("Alphanumeric ({{example1}}, {{example2}}, {{example3}} …)", {
      example1: "A–Z",
      example2: "0–50",
      example3: "A-01",
    }),
  },
];

export const SEQUENCE_RULE_OPTIONS: { key: keyof RevisionSequenceRules; label: string }[] = [
  { key: "allowSkipFirst", label: t("Allow skipping first number") },
  { key: "allowSkipIntermediate", label: t("Allow skipping intermediate numbers") },
  { key: "allowAnyOrder", label: t("Allow any order") },
  { key: "noRepeatedRevisions", label: t("Allow skipping Previous Revision") },
  { key: "revisionMandatory", label: t("Revision Mandatory on Import") },
];
